// This is needed to prevent error with React.lazy. I think this is related to React 18 version and upgrade to 19 should fix that problem
import { lazy } from "react";
import type { RouteComponent } from "@onhandtech/onhand-fe-shared/lib/contracts/router/router";
import type { RouteKey } from "contracts/config/routes";

export const routeMap: RouteComponent<RouteKey>[] = [
	{
		key: "SIGN_IN",
		component: lazy(() => import("../pages/auth/sign-in/sign-in")),
	},
	{
		key: "FORGOT_PASSWORD",
		component: lazy(
			() => import("../pages/auth/forgot-password/forgot-password"),
		),
	},
	{
		key: "CODES",
		component: lazy(() => import("../pages/admin/signup-codes/signup-codes")),
	},
	{
		key: "CODE_DETAILS",
		component: lazy(
			() => import("../pages/admin/signup-codes/sub-pages/code-details"),
		),
	},
	{
		key: "MISSIONS",
		component: lazy(() => import("../pages/admin/missions/missions")),
	},
	{
		key: "QR_CODE",
		component: lazy(() => import("../pages/admin/qr-codes/qr-codes")),
	},
	{
		key: "CONTENT",
		component: lazy(() => import("../pages/admin/content/content")),
	},
	{
		key: "ACTIONS",
		component: lazy(() => import("../pages/admin/content/content")),
	},
	{
		key: "SECTIONS",
		component: lazy(() => import("../pages/admin/content/content")),
	},
	{
		key: "CAMPAIGNS",
		component: lazy(() => import("../pages/admin/content/content")),
	},
	{
		key: "EDIT_SECTION",
		component: lazy(
			() =>
				import("../pages/admin/content/sub-sections/sections/edit-section/edit-section"),
		),
	},
	{
		key: "EDIT_CAMPAIGN",
		component: lazy(
			() =>
				import("../pages/admin/content/sub-sections/campaigns/edit-campaign/edit-campaign"),
		),
	},
	{
		key: "CREATE_ORG",
		component: lazy(
			() => import("../pages/admin/create-organisation/create-organisation"),
		),
	},
	{
		key: "ROOT",
		component: lazy(() => import("../pages/auth/sign-in/sign-in")),
	},
];
